import { render, staticRenderFns } from "./BulkFixFulcrumIssuesFailures.vue?vue&type=template&id=6f19e880&scoped=true&"
import script from "./BulkFixFulcrumIssuesFailures.vue?vue&type=script&lang=js&"
export * from "./BulkFixFulcrumIssuesFailures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f19e880",
  null
  
)

export default component.exports